import { Component, Input } from '@angular/core';
import { PrintResultDto, ProjectDto } from '../../../core/services/GPRMV1Service.Generated';

@Component({
    selector: 'app-print-first-page-header',
    templateUrl: './print-first-page-header.component.html',
    styleUrls: ['./print-first-page-header.component.scss'],
    standalone: false
})
export class PrintFirstPageHeaderComponent {
    @Input() printData: PrintResultDto = ({
        mainCharacteristics: [],
        createdByUserName: '',
        organisationName: '',
        materialsAppVersionNumber: 0,
        lastNmdProductUpdateDate: undefined
    } as unknown) as PrintResultDto;

    @Input() calculationName: string = '';

    @Input() projectCharacteristics: ProjectDto = ({
        id: undefined,
        streetName: '',
        houseNumber: undefined,
        houseNumberAddition: undefined,
        houseLetter: '',
        postalCode: '',
        town: '',
        client: '',
        architect: '',
        buildingPermitDate: undefined,
        phaseId: undefined,
        statusId: undefined,
        purposeValue: undefined
    } as unknown) as ProjectDto;

    @Input() isProjectPhaseUIEnabled: boolean = false;
    @Input() isExistingBuildingCal: boolean = false;
    @Input() parameterGroupsCache: Map<any, any[][]> = new Map();
    @Input() selectedsubmenu: string;
    @Input() levensduurHuidig: number = 0;
    @Input() resterendLevensduurHuidig: number = 0;
    @Input() levensduurIngreep: number = 0;
    @Input() resterendLevensduurIngreep: number = 0;


    readonly printDate: Date = new Date();

    get pageTitle(): string {
        switch (this.selectedsubmenu) {
            case 'mpg':
                return 'PRINT_PAGE.TITLE_FOR_MPG';
            case 'extraindicators':
                return 'PRINT_PAGE.TITLE_FOR_EXTRAINDICATORS';
            case 'materialpassport':
                return 'PRINT_PAGE.TITLE_FOR_MATERIALPASSPORT';
            case 'all':
            default:
                return 'PRINT_PAGE.TITLE_FOR_ALL';
        }
    }

    get preparedBy(): string {
        return (this.printData && this.printData.createdByUserName);
    }

    get organisationName(): string {
        return (this.printData && this.printData.organisationName);
    }

    /** Returns true when the value is a JSON array or object string (should be hidden from the print view). */
    isJsonValue(value: string | undefined): boolean {
        if (!value) return false;
        const trimmed = value.trim();
        return trimmed.startsWith('[') || trimmed.startsWith('{');
    }

    /**
     * Gets the cached parameter groups for a main characteristic.
     * @param characteristic The main characteristic to get parameter groups for
     * @returns Array of parameter groups, each containing up to 4 parameters
     */
    getParameterGroups(characteristic: any): any[][] {
        return this.parameterGroupsCache.get(characteristic) || [];
    }

    /**
     * Checks if building characteristics has 3 or more columns.
     * Returns true if any main characteristic has 9 or more parameters (which creates 3+ columns).
     * @returns True if 3 or more columns are needed, false otherwise
     */
    hasThreeOrMoreColumns(): boolean {
        if (!this.printData?.mainCharacteristics) {
            return false;
        }

        return this.printData.mainCharacteristics.some(characteristic => {
            const paramGroups = this.parameterGroupsCache.get(characteristic);
            return paramGroups && paramGroups.length >= 3;
        });
    }
}
